import styled from "styled-components";
import { colors } from "@/theme";

export const ShippingInfoContainer = styled.div`
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  align-items: center;

  & > div:nth-of-type(3) {
    margin-bottom: 14px;
  }
`;

export const ShippingInfoValue = styled.div`
  color: ${colors.black};
  text-align: center;
  font-family: "PF DIN Text Pro";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;
